import { Option, SliderData } from './types';
import { StateDependant } from './utils';

export const CLASS_OPEN = 'is-bundle-builder-open';

const getColorMarkup = (step_id, data:Option) => {
  const template = document.createElement('template');
  const colorName = data.title.toLowerCase().replace(/ /g,'-');
  const colorNameSplit = data.title.split('-');
  const sanitizedColor = colorNameSplit[colorNameSplit.length - 1].trim();

  template.innerHTML = `
    <style>
      .is-hidden {
        opacity: 0.1;
      }

      .label {
        display: flex;
        align-items: center;
        flex-direction: column;
        background-color: #fff;
        transition: all 0.3s;
      }

      .icon { 
        width: 60%;
      }

      .dependency-text {
        background-color: #c84242;
        color: #fcfcfb;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        width: 70%;
        transition: opacity 0.3s;
        padding: .5rem 1rem;
        border-radius: .5rem;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        cursor: not-allowed;
      }

      :host {
        width: 3.125rem;
      }

      :host(.is-disabled) .label {
        opacity: 0.5;
      }

      :host(.is-disabled) .label:hover + .dependency-text {
        opacity: 1;
      }

      .o-swatch {
        border-radius: .75rem;
        border: 1px solid transparent;
        transition: all .2s;
        cursor: pointer;
        position: relative;
      }

      .o-swatch.is-selected,
      .o-swatch:hover {
        border-color: #163021;
      }

      .o-swatch .o-swatch__disable {
        display: none;
        position: absolute;
        top: -100%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        width: 200%;
        background-color: white;
        padding: 1rem;
        border-radius: 3px;
      }

      .o-swatch[disabled]:hover .o-swatch__disable {
        display: block;
      }
      
      [disabled] .o-swatch__inner {
        opacity: 0.5;
        cursor: not-allowed;
      }


      .o-swatch__inner {
        border-radius: .75rem;

        display: block;
        width: 100%;
        position: relative;
        box-shadow: none;
        padding: 0 0 100%;
        margin: 0;
      }

      .is-selected .o-swatch__inner {
        box-shadow: none;
      }
    
      .o-swatch__inner-color {
        width: 100%;
      }

      .o-swatch__inner img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border-radius: .75rem;
        transition: all 0.3s;
      }

      .o-swatch.is-selected .o-swatch__inner img,
      .o-swatch:hover .o-swatch__inner img {
        width: calc(100% - .375rem);
        height: calc(100% - .375rem);
        border-radius: .5rem;
      }

      @media only screen and (max-width: 1099px) {
        .o-swatch .o-swatch__disable {
          position: fixed;
          top: 30%;
          left: 4rem;
          right: 4rem;
          width: auto;
          line-height: 1.3;
          transform: translate(0, -50%);
          box-shadow: 0 0 .625rem #F5F2F0);
          border-radius: 0.5rem;
          pointer-events: none;
        }
      }

      @media only screen and (min-width: 1100px) {
        :host {
          width: 5rem;
        }

        .o-swatch {
          border-radius: 1rem;
          border: 1px solid transparent;
          transition: all .2s;
          cursor: pointer;
        }

        .o-swatch__inner,
        .o-swatch.is-selected .o-swatch__inner img,
        .o-swatch:hover .o-swatch__inner img {
          border-radius: .75rem;
        }
      }
    </style>
    
    <input class="input" hidden type="radio" id="${data.option_id}" name="${step_id}" ${data.disable_for_product ? 'disabled' : '' }>

    <label
      class="label o-customiser__color-swatch-inner o-swatch"
      data-swatch-object
      data-value="${colorName}"
      title="${sanitizedColor}"
      data-sample-variant-id="${data.sample_variant_id}"
      ${data.sample_variant_availability ? `data-sample-available="${data.sample_variant_availability}"` : ``}
      ${data.disable_for_product ? 'disabled' : '' }
      for="${data.option_id}"
    >
      <span class="o-swatch__disable">${data.product_disable_message}</span>
      <span class="o-swatch__inner">
        <img loading="lazy" src="${data.colorImage}" /">
      </span>
    </label>
  `;
  
  return template;
}

export class CustomiserColor extends StateDependant {
  private data;
  private option_id:string;
  private option_title:string;
  private sample_variant_id:string;
  private image:string;
  private sample_variant_availability:string;
  private hem:'SEWN'|'WEIGHTED';
  private style_type:string;// StyleType 
  private default_variant_id:string; // Default variant id
  private variant_id:string;
  private disable_for_product:string;
  private disable_for_sample:string;
  private sample_disable_message:string;
  // private model_id:string;
  private cost:string;
  private slider_data: SliderData;

  private step_id:string|null = this.getAttribute('step-id');
  private isSelected:boolean = false;
  constructor() {
    super();

    const data = this.getAttribute('data');

    if (!this.step_id) {
      console.error('Need to supply a step-id for this option!', this);
      return;
    }
    if (!data) {
      console.error('Need to supply some data for this option!', this);
      return;
    }
    this.data = JSON.parse(data)!;
    this.option_id = this.data.option_id;
    this.option_title = this.data.title;
    this.sample_variant_id = this.data.sample_variant_id;
    this.sample_variant_availability = this.data.sample_variant_availability;
    this.hem = this.data.hem;
    this.style_type = this.data.style_type;
    this.cost = this.data.cost ? this.data.cost : "0";
    this.image = this.data.colorImage;
    this.default_variant_id = this.data.default_variant_id;
    this.variant_id = this.data.variant_id;
    this.disable_for_product = this.data.disable_for_product;
    this.disable_for_sample = this.data.disable_for_sample;
    this.default_state = this.disable_for_product ? 'Disabled' : 'Visible';
    this.sample_disable_message = this.data.sample_disable_message;
    this.slider_data = this.data.slider_data

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getColorMarkup(this.step_id, this.data);
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.optionLabel = shadowRoot.querySelector('.label');
    this.optionInput = shadowRoot.querySelector('.input');
    this.swatch = shadowRoot.querySelector('.o-swatch');

    this.addEventListener('click', () => this.handleChange());
    
    this.setState(this.default_state);
  }

  setSelected(val:boolean) {
    this.isSelected = val;
    this.swatch?.classList.toggle('is-selected', this.isSelected);
    this.optionInput?.toggleAttribute('checked', this.isSelected);
  }

  handleChange() {
    if (this.isDisabled) return;
    const evt = new CustomEvent('color_change', {
      detail: {
        option_id: this.option_id,
        option_title: this.option_title,
        sample_variant_id: this.sample_variant_id,
        sample_variant_availability: this.sample_variant_availability,
        hem: this.hem,
        style_type: this.style_type,
        step_id: this.step_id,
        image: this.image,
        default_variant_id: this.default_variant_id,
        variant_id: this.variant_id,
        sample_disable_message: this.sample_disable_message,
        slider_data: this.slider_data
      },
      bubbles: true,
      composed: true
    });
    
    document.dispatchEvent(evt);
    this.dispatchEvent(evt);
  }
}

if (!customElements.get('customiser-color')) {
  customElements.define('customiser-color', CustomiserColor);
}